import { useEffect, useState } from "react";
import axios from "axios";
import { TrendingUp, TrendingDown } from "lucide-react";
import { API, TICKER_SEED } from "@/data/content";

export default function MarketTicker() {
  const [quotes, setQuotes] = useState(TICKER_SEED);
  const [live, setLive] = useState(false);

  useEffect(() => {
    let alive = true;
    const fetchQuotes = async () => {
      try {
        const { data } = await axios.get(`${API}/quotes`);
        if (alive && data?.quotes?.length) {
          setQuotes(data.quotes);
          setLive(!!data.live);
        }
      } catch {
        /* keep seed */
      }
    };
    fetchQuotes();
    const t = setInterval(fetchQuotes, 15000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, []);

  const items = [...quotes, ...quotes];
  return (
    <div
      data-testid="market-ticker"
      className="marquee-hover-pause fixed inset-x-0 top-0 z-[110] flex h-9 items-center overflow-hidden border-b border-line bg-[#050507] text-white"
    >
      <div className="z-10 flex h-full shrink-0 items-center gap-2 border-r border-line bg-[#050507] px-3">
        <span
          className={`pulse-dot h-1.5 w-1.5 rounded-full ${live ? "bg-up" : "bg-gold"}`}
        />
        <span
          data-testid="ticker-mode-badge"
          className={`font-mono text-[9px] font-bold uppercase tracking-[0.2em] ${
            live ? "text-up" : "text-gold"
          }`}
        >
          {live ? "Live" : "Simulated"}
        </span>
      </div>
      <div
        className="animate-marquee flex whitespace-nowrap"
        style={{ "--marquee-speed": "45s" }}
      >
        {items.map((q, i) => {
          const positive = q.change_pct >= 0;
          return (
            <span
              key={`${q.symbol}-${i}`}
              className="mx-5 inline-flex items-center gap-2 font-mono text-[11px]"
            >
              <span className="font-bold text-neutral-200">{q.symbol}</span>
              {q.proxy && (
                <span className="-ml-1 text-[8px] uppercase text-neutral-500">
                  via {q.proxy}
                </span>
              )}
              <span className="text-neutral-400">
                {q.price.toLocaleString(undefined, { minimumFractionDigits: 2 })}
              </span>
              <span
                className={`inline-flex items-center gap-0.5 ${
                  positive ? "text-up" : "text-brand"
                }`}
              >
                {positive ? <TrendingUp size={11} /> : <TrendingDown size={11} />}
                {positive ? "+" : ""}
                {q.change_pct}%
              </span>
            </span>
          );
        })}
      </div>
    </div>
  );
}
